import { css } from '@emotion/core';
import { fonts, colors } from 'styles';

export const items = css`
  overflow: auto;
  max-height: 241px;
`;
